import React, { Component } from "react";
import Wrp from "../../../../hoc/Wrp/Wrp";
import AceEditor from "react-ace";
import { callPOST } from "../../../../Utils/ApiUtil";
import HtmlPdfPReview from "../../../PDFContainer/HtmlPdfPReview";
import Buttons from "../../../../Components/UI/Buttons";
import ImageDetails from "../../../PDFContainer/PDFCreate/HtmlContent/ImageDetails";
import * as ShipConstants from "../../../../Global/Constants";
import ModalBox from "../../../../Components/UI/Modal";
import { HtmlCodeInstructionNote } from "./HtmlCodeInstructionNote";
import HtmlBuilder from '../../../../Components/HtmlBuilder';


class DomainProcess3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        domain_id: props.item.id,
        is_custom_login_active: true,
        login_html_code: "",
        login_css: "",
        htmlBuilderObj:''
      },
      imageData: {
        id: null,
        data: []
      },
      isPreviewOpen: false,
      instructionModelOpen:false,
      activeTab: 'htmlContent',
    }
  }
  uploadMultipleFiles = React.createRef();

  componentDidMount = () => {
    const { item } = this.props
    if (item !== undefined && item !== null) {
      let updateState = this.state.formData;
      updateState.login_html_code = (item.login_html_code !== undefined) ? item.login_html_code : '';
      updateState.login_css = (item.login_css !== undefined) ? item.login_css : '';
      updateState.is_custom_login_active = item.custom_login_acive;
      this.setState({
        formData: updateState,
        imageData: { id: null, data: (item.images !== undefined) ? JSON.parse(item.images) : [] }
      })
    }
  }
  onChangeHandler = (e) => {
    const { name, type } = e.target;
    let value = e.target.value;
    let updatedFormData = this.state.formData;
    if (type !== undefined && type === "checkbox") {
      value = e.target.checked
    }
    if (name !== undefined && name !== "") {
      updatedFormData[name] = value;
      this.setState({
        formData: updatedFormData
      })
    }
  }
  htmlContentChangeHandler = (newValue) => {
    let updateState = this.state.formData;
    updateState.login_html_code = newValue;
    this.setState({ formData: updateState });
  }
  cssContentChangeHandler = (newValue) => {
    let updateState = this.state.formData;
    updateState.login_css = newValue;
    this.setState({ formData: updateState });
  }
  modelChangeHandler=()=>{
    this.setState({
      instructionModelOpen:!this.state.instructionModelOpen
    })
  }

  onValidate = () => {
    console.log("onValidate");
  }


  saveFromHTMLBuilder = async (htmlData,htmlBuilderObj) => {
    console.log('saveFromHTMLBuilder===',htmlData)
    const updateState = {...this.state};
      updateState['formData']['login_html_code']=htmlData;
      updateState['formData']['htmlBuilderObj']=htmlBuilderObj;
    await this.setState(updateState);
    await this.saveHandler();   
  }

  saveHandler = (isImage=false) => {
    console.log("saveHtml code", this.state);
    const { formData, imageData } = this.state;
    const {item} = this.props;
    let htmlImages = [];
    if (imageData.data) {
      imageData.data.map((arr, i) => {
        const val = {
          id: arr.id,
          value: arr.label
        }
        htmlImages.push(val);
      })
    }

    const custom_html = JSON.stringify(formData.htmlBuilderObj);
    const body = {
      domain_id: formData.domain_id,
      is_custom_login_active: (isImage===true)?item.custom_login_acive:formData.is_custom_login_active,
      login_html_code: (isImage===true)?item.login_html_code:formData.login_html_code,
      login_css: (isImage===true)?item.login_css:formData.login_css,
      images: htmlImages,
      custom_html : custom_html,
    }
    
    const header = { 'Content-Type': 'application/json' };
    callPOST("domain/login-page/upload", body, header)
      .then(res => {
        console.log("Response domain html Save", res);
        if (res.status === 200) {
          const resData = res.data;
          if (resData.code === 200) {
            if(isImage===true){
              this.props.succMessage("Image Uploaded Successfully");
                        
            }else if (isImage===false && resData.data !== undefined && resData.data !== null && resData.data.login_html_code !== undefined) {
              this.props.succMessage(resData.message);
              this.setState({
                formData: {
                  ...this.state.formData,
                  login_html_code: resData.data.login_html_code,
                  login_css : resData.data.login_css
                }
              })
            }
          } else {
            let generalViolationMessage = '';
            if (resData.violations.length > 0) {
              resData.violations.map((item, index) => {
                generalViolationMessage += item.message + '<br/>';
              });
              if (generalViolationMessage !== '') {
                this.props.failMessage(generalViolationMessage);
              } else {
                this.props.failMessage(resData.message);
              }
            } else {
              this.props.failMessage(resData.message);
            }
          }
        } else {
          this.props.failMessage("Unable to save Html code");
        }
      }, (error) => {
        console.log("Error : ", error);
      })
  }
  uploadCSSContent = () => {

    const { formData } = this.state;
    return (
      <div>
        <div>
          <AceEditor
            // value={formData.login_css}
            // ref="aceEditor"
            // mode="css"
            // theme="github"
            // fontSize={12}
            // width="100%"
            // name="html_code"
            // showPrintMargin={true}
            // editorProps={{ $blockScrolling: true }}
            // onChange={this.cssContentChangeHandler}
            // onValidate={this.onValidate} 
            // setOptions={{
            //   fontSize: '12px'
            // }}
            value={formData.login_css}
            ref="aceEditor"
            mode="css"
            theme="github"
            fontSize={14}
            width="100%"
            name="css"
            showPrintMargin={false}
            editorProps={{ $blockScrolling: true }}
            onChange={this.cssContentChangeHandler}
            setOptions={{
              fontSize: '14px'
            }}
          />
        </div>
      </div>
    )
  }

  preViewToggleHandler = () => {
    console.log("preViewToggleHandler");
    console.log("")
    this.setState({
      isPreviewOpen: !this.state.isPreviewOpen
    })
  }

  uploadCSSHandler = () => {
    const { formData } = this.state;
    const body = {
      domain_id: formData.domain_id,
      is_custom_login_active: formData.is_custom_login_active,
      login_css: formData.login_css
    }
    const header = { 'Content-Type': 'application/json' };
    callPOST("domain/login-page/upload", body, header)
      .then(res => {
        console.log("Response domain html Save", res);
        if (res.status === 200) {
          const resData = res.data;
          if (resData.code === 200) {
            this.props.succMessage(resData.message);
            if (resData.data !== undefined && resData.data !== null && resData.data.login_css !== undefined) {
              this.setState({
                formData: {
                  ...this.state.formData, login_css: resData.data.login_css
                }
              })
            }
            this.props.toggelModel("uploadCSS");
          } else {
            let generalViolationMessage = '';
            if (resData.violations.length > 0) {
              resData.violations.map((item, index) => {
                generalViolationMessage += item.message + '<br/>';
              });
              if (generalViolationMessage !== '') {
                this.props.failMessage(generalViolationMessage);
              } else {
                this.props.failMessage(resData.message);
              }
            } else {
              this.props.failMessage(resData.message);
            }
          }

        } else {
          this.props.failMessage("Unable to save CSS code");
        }
      }, (error) => {
        console.log("Error : ", error);
      })
  }

  deleteUploadFiles = (ind) => {
    console.log("deleteUploadFiles", "index", ind);
    let updateFiles = this.state['imageData']['data'];
    updateFiles = updateFiles.filter((item, index) => {
      if (index !== ind) {
        return item;
      }
    })
    const updateState = { ...this.state };
    updateState['imageData']['data'] = updateFiles ? updateFiles : [];
    this.setState(updateState);
  }

  uploadFilesHandler = (e) => {
    console.log("uploadFilesHandler");
    this.uploadFileAPICall(e.target.files);
  }

  uploadFileAPICall = (files) => {
    console.log('upload api call');
    let totalFileLength = files.length;
    Object.entries(files).map(([key, fileItem]) => {
      const formData = new FormData();
      formData.append("upload_file", fileItem);
      const APIURL = 'files/upload';
      callPOST(APIURL, formData, { 'Content-Type': 'multipart/form-data' })
        .then(res => {
          console.log("respnse",res);
          if (res.status == 200) {
            const response = res.data;
            if (response.code === ShipConstants.API_STATUS_SUCCESS) {
              const responseData = response.data;
              const updateState = { ...this.state };
              const data = { id: responseData, label: responseData, file: fileItem };
              updateState['imageData']['data'].push(data);
              this.setState(updateState);
             
                this.saveHandler(true);
             } else {
              // this.props.failMessage((res.message!=='')?res.message:'Something went wrong..');
            }
          } else {
            // this.props.Loader();
            // this.props.failMessage('Something went wrong..');
          }
        })
        .catch(err => {
          console.log(err);
          // this.props.Loader();
          // this.props.failMessage('Something went wrong');                    
        })
    })
  }
  tabChangeHandler = (tab) => {
    console.log("tab", tab);
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({
        activeTab: tab
      })
    }
  }

  onFileChange = () => {
    let inputField = this.uploadMultipleFiles;
    inputField.click();
  }

  insertTextHandler = (content, type, dependentWindowName = '') => {
    const params = this.props.match.params;
    let textToInsert = '';
    if (type === 'img') {
      textToInsert = "SCM-SRC(" + content + ")";
    }
    const reactAceComponent = this.refs.aceEditor;

    const editor = reactAceComponent.editor;
    var cursorPosition = editor.getCursorPosition();
    editor.getSession().insert(cursorPosition, textToInsert);
  }




  render() {
    const { stepNavigation, toggelModel, OpenModels } = this.props;
    const { formData, isPreviewOpen, activeTab,instructionModelOpen } = this.state;
    console.log("htmlCode", formData.login_html_code);

    const previewData = {
      id: null,
      designName: '',
      description: '',
      isActive: true,
      isDefault: true,
      htmlContent: "<style>" + replaceAndUpdateFileLink(formData.login_css) + "</style>" + replaceAndUpdateFileLink(formData.login_html_code),
      iterateData: {},
      format: 'A4',
      width: 210,
      height: 297,
      formatOptions: [{ value: 'A0', label: 'A0', width: 841, height: 1189 }, { value: 'A1', label: 'A1', width: 594, height: 841 }, { value: 'A2', label: 'A2', width: 420, height: 594 }, { value: 'A3', label: 'A3', width: 297, height: 420 }, { value: 'A4', label: 'A4', width: 210, height: 297 }, { value: 'A5', label: 'A5', width: 148, height: 148 }, { value: 'Letter', label: 'Letter', width: 216, height: 279 }, { value: 'Legal', label: 'Legal', width: 216, height: 330 }, { value: 'Tabloid', label: 'Tabloid', width: 841, height: 1189 }, { value: 'Custom', label: 'Custom', width: 0.00, height: 0.00 }],

      designName_error: ''
    }
    const modalButtonList = [
      {
        attributes: {
          className: "btn border-default btn-border",
        },
        clickHandler: toggelModel.bind(this, "uploadCSS"),
        name: "Cancel"
      },
      {
        clickHandler: this.uploadCSSHandler.bind(this),
        attributes: {
          "className": "btn primary_bg ml-2",
        },
        name: "Save"
      }

    ];

    const LoginActionButtons = [
      {
        name: "Email Field",
        type: "InputField"
      }, {
        name: "Password Field",
        type: "InputField"
      }, {
        name: "Forgot Password",
        type: "Button"
      }, {
        name: "Login Button",
        type: "Button"
      }, {
        name: "Show Password",
        type: "checkbox"
      }

    ]

    let sampleHtmlCode = "<html><style>" + formData.login_css + "</style>" + formData.login_html_code + "</html>";


    const actionBtn = [
      {
        className: "btn-group align-right d-flex",
        isButtonGroup: true,
        list: [

          // {
          //   attributes: {
          //     className: "btn btn-border border-default",
          //   },
          //   clickHandler: toggelModel.bind(this, "uploadCSS"),
          //   name: <span className="d-sm-none d-md-block d-none"> Style Sheet</span>,
          //   type: "addNew",
          // },
          {
            attributes: {
              className: "btn btn-border border-default",
            },
            clickHandler: this.preViewToggleHandler.bind(this),
            name: <span className="d-sm-none d-md-block d-none"> Preview</span>,
            type: "Preview",
          },
          {
            attributes: {
              className: "btn primary_bg mr-1 ml-2",
            },
            clickHandler: () => this.saveHandler(),
            name: <span className="d-sm-none d-md-block d-none">Save</span>,
            type: "Save",
          }
        ]
      }
    ]

    let breadCrumbs = {}
    let htmlContentData = {}
    let builderObject = {
      breadCrumbsList:breadCrumbs,
      //variableList:variableList,      
      //drillDownNextLevel:this.drillDownNextLevel,
      //goBackDrillDown:this.goBackDrillDown,
      htmlContentData:formData,        
      isPreviewModalOpen:this.state.isPreviewOpen,
      previewModaltoggleHandler:this.preViewToggleHandler,
      saveFromHTMLBuilder:this.saveFromHTMLBuilder,
      failMessage:this.props.failMessage,
      succMessage:this.props.succMessage,
      refAtt:this.props.refAtt,
      onChangeHandler:this.onChangeHandler,
      actionBtn:actionBtn      
      //pdfDetails:pdfDetails
    }


    return (
      <Wrp>
         <ModalBox title="Html Code Actions Usage" zIndex={'1200'} isModalOpen={instructionModelOpen} buttonList={[{
            name:'close',
            attributes:{
                className:'btn border-default btn-border'
            },
            clickHandler:()=>this.modelChangeHandler()
        }]}>
          <HtmlCodeInstructionNote />
        </ModalBox>

        {/* <HtmlBuilder 
          pageFrom='Domain'
          builderObject={builderObject}                   
        /> */}

        <div className="view  view-xl">
          <div className="view view--hor-scroll">
            <div className="card_Box">
              <div className="row">
                <div className="col-12 " ref={this.props.refAtt}>
                  <div className="card mb-0">
                    <div className="card-header p-2">
                      <div className="card-title">
                        <div className="mx-auto">
                          <div className="material-switch p-2">
                            <span className="mr-4">Is Active Login</span>
                            <input id="custom_login"
                              name="is_custom_login_active"
                              type="checkbox"
                              checked={(formData.is_custom_login_active) === true ? true : false}
                              onChange={(e) => this.onChangeHandler(e)}
                            />
                            <label htmlFor="custom_login" className="secondary_bg"></label>
                            <div className="float-right"> <Buttons buttonList={actionBtn} /></div>

                          </div>
                        </div>

                      </div>
                    </div>
                    <div className="card-body pb-0">
                      <div className="d-flex">
                        <div className="w-100 pr-1 mr-1">
                          <div className="card-header cursor-pointer sectionHeader pl-1 p-2 position-relative" >
                            <ul className="nav nav-pills navcrm-primary nav-pills-no-bd px-2" role="tablist" >
                              <li className="nav-item" name="htmlTab" onClick={() => this.tabChangeHandler("htmlContent")}>
                                <a data-toggle="tab" role="tab" name="" aria-selected="true" className="nav-link show active" >
                                   HTML Code  <Buttons buttonList={[{
                                        name:'',
                                        clickHandler:()=>this.modelChangeHandler(),
                                        attributes:{title:'',},
                                        svgIcon:'InfoIcon'
                                    }]} /> </a>
                              </li>
                              <li className="nav-item" name="cssTab" onClick={() => this.tabChangeHandler("cssContent")}>
                                <a data-toggle="tab" role="tab" name="cssTab" className="nav-link" > CSS Code </a>
                              </li>
                            </ul>
                          </div>
                          <div className="form-group">                            
                            {(activeTab === "htmlContent") ?
                              <div className="customTextArea" id="customTextArea">
                                <AceEditor
                                  value={formData.login_html_code}
                                  ref="aceEditor"
                                  mode="html"
                                  theme="github"
                                  fontSize={14}
                                  width="100%"
                                  name="html_code"
                                  showPrintMargin={false}
                                  editorProps={{ $blockScrolling: true }}
                                  onChange={this.htmlContentChangeHandler}
                                  setOptions={{
                                    fontSize: '14px'
                                  }}
                                />
                              </div> :
                              <div className="customTextArea">
                                <AceEditor
                                  // value={formData.login_css}
                                  // ref="aceEditor"
                                  // mode="css"
                                  // theme="github"
                                  // fontSize={12}
                                  // width="100%"
                                  // name="html_code"
                                  // showPrintMargin={true}
                                  // editorProps={{ $blockScrolling: true }}
                                  // onChange={this.cssContentChangeHandler}
                                  // onValidate={this.onValidate} 
                                  // setOptions={{
                                  //   fontSize: '12px'
                                  // }}
                                  value={formData.login_css}
                                  ref="aceEditor"
                                  mode="css"
                                  theme="github"
                                  fontSize={14}
                                  width="100%"
                                  name="css"
                                  showPrintMargin={false}
                                  editorProps={{ $blockScrolling: true }}
                                  onChange={this.cssContentChangeHandler}
                                  setOptions={{
                                    fontSize: '14px'
                                  }}
                                />
                              </div>
                            }                            
                          </div>
                        </div>                        

                        {
                          (isPreviewOpen === true) ?
                            <HtmlPdfPReview
                              isModalOpen={isPreviewOpen}
                              toggleHandler={this.preViewToggleHandler}
                              pdfdata={previewData}
                              previewScreen="new" />
                            : null
                        }
                        <ImageDetails
                          uploadMultipleFiles={this.uploadMultipleFiles}
                          uploadFilesHandler={this.uploadFilesHandler}
                          onFileChange={this.onFileChange}
                          copyPrefix="SCM-SRC("
                          copySuffix=")"
                          imageData={this.state.imageData}
                          deleteUploadFiles={this.deleteUploadFiles}
                          insertTextHandler={this.insertTextHandler}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card_Footer ju">
          <div>
            <button className="btn btn-border border-default" type="submit" onClick={() => stepNavigation(3, true, false)} > {" "} Previous{" "} </button>
          </div>
          <button className="btn primary_bg" type="submit" onClick={() => stepNavigation(3, false, true)} > {" "} Continue </button>
        </div>
      </Wrp>
    )

  }
}
export default DomainProcess3;

export const replaceAndUpdateFileLink = (content) => {
  // console.log("replaceAndUpdateFileLink");
  let htmlContent = "";
  if (content !== undefined && content !== null) {
    htmlContent = content;
  }
  const regex = /[^SCM-SRC(\}]+(?=\))/g;
  const filesIds = htmlContent.match(regex);
  if (htmlContent.match(regex) && filesIds.length > 0) {
    filesIds.map((file) => {
      // console.log("file View", file);
      htmlContent = htmlContent.replace("SCM-SRC(" + file + ")", ShipConstants.API_URL + "files/download?fileId=" + file);
    })
  }
  return htmlContent;
}